import { GetPartnerWorkerResponse } from 'partner/shared/services/partner-worker-service.types';
import { useTranslation } from 'react-i18next';
import { ModalPanelTabType } from 'redesign';
import { PartnerWorkerDetailAccreditations } from '../partner-worker-detail-modal/partner-worker-detail-accreditations';
import { PartnerWorkerDetailExperience } from '../partner-worker-detail-modal/partner-worker-detail-experience';

enum PartnerWorkerDetailTab {
  ACCREDITATIONS = 'accreditations',
  EXPERIENCE = 'experience',
}

export const useGetPartnerWorkerDetailTabs = (data: GetPartnerWorkerResponse) => {
  const { t } = useTranslation('partner-screen-specific');
  const tabs: ModalPanelTabType[] = [
    {
      id: PartnerWorkerDetailTab.ACCREDITATIONS,
      tabLabel: t('partner_worker_detail_tabs.accreditations'),
      element: <PartnerWorkerDetailAccreditations accreditations={data.accreditations} />,
    },
    {
      id: PartnerWorkerDetailTab.EXPERIENCE,
      tabLabel: t('partner_worker_detail_tabs.experience'),
      element: <PartnerWorkerDetailExperience data={data} />,
    },
  ];

  return tabs;
};
